export const isCurrentPage = (path: string) => {
  if (window.location.href.includes(path)) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/helpers/pageLocationHelper.ts